import React from 'react';

const SubBullet = ({ fill = '#222222', ...props }: { fill?: string } & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M2.99991 5H1.99991V10V11H2.99991H7.99991V10H2.99991V5Z" fill={fill} />
    </svg>
  );
};

export default SubBullet;
